
export const loadAuthState = () => {
    try {
        const serializedState = localStorage.getItem('auth');
        const sessionSerializedState = sessionStorage.getItem('auth');

        if (serializedState === null && sessionSerializedState === null) {
            return undefined;
        }

        if (sessionSerializedState !== null) {
            return JSON.parse(sessionSerializedState);
        } else if (serializedState !== null) {
            const { state, expirationDate } = JSON.parse(serializedState)
            if (!state.auth.keep_login || Date.now() > expirationDate) {
                localStorage.removeItem("auth");
                return undefined; // Expired state
            }
            return state;
        }


    } catch (error) {
        return undefined;
    }
}

export const saveAuthState = (state) => {
    try {
        const expirationDate = Date.now() + 60 * 24 * 60 * 60 * 1000;

        const serializedState = JSON.stringify({ state, expirationDate });
        localStorage.setItem('auth', serializedState);
        sessionStorage.setItem('auth', JSON.stringify(state));
    } catch (error) {
        console.log('session could not be saved!');
    }

}